var _rect, _rect2, _path, _g, _g2, _path2, _path3, _path4, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6013_6613)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 10963,
    transform: "translate(-256 -5505)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-259 57.5442C-206.667 73.7108 -57.3 85.8442 121.5 5.04415C225 -50.4558 400.5 -0.955849 464 48.0442C527.5 97.0442 771 91.0442 836 48.0442C901 5.04415 1015.5 -50.9558 1187 17.5442",
    stroke: "#005A9E",
    strokeWidth: 2,
    strokeDasharray: "12 12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6013_6613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -42,
    y: -42.4453,
    width: 113.765,
    height: 113.765,
    rx: 56.8824,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6013_6613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -47.6484,
    y: -46.1855,
    width: 38.68,
    height: 38.68,
    rx: 19.34,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6013_6613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.43945H27.75L26.3333 27.5645H3.66667L2.25 8.43945Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 11.2728V2.06445H20.6673V11.2728",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 21.8979H20.6673",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6013_6613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 -2.18555H32V31.8145H-2V-2.18555Z",
    fill: "#005A9E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6013_6613",
    x: -70.4412,
    y: -66.3359,
    width: 170.647,
    height: 170.647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.55059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2206
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6013_6613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6013_6613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6013_6613",
    x: -76.0896,
    y: -70.0762,
    width: 95.5624,
    height: 95.5624,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.55059
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.2206
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6013_6613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6013_6613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6013_6613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 10963,
    fill: "white",
    transform: "translate(-256 -5505)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b7ae1f1abcd95326237d9f7df85282ad.svg";
export { ForwardRef as ReactComponent };